'use client';

import { useTranslations } from 'next-intl';

import PageLayout from '@/app/components/PageLayout';
import AlertErrorDynamic from '@/app/components/SignIn/AlertErrorDynamic';
import InternalSignInLink from '@/app/components/SignIn/InternalSignInLink';
import SignInButtonDynamic from '@/app/components/SignIn/SignInButtonDynamic';
import BulkOrderBackground from '@/app/components/ui/BulkOrderBackground';
import { ShadCard } from '@/app/components/ui/Card/card';
import { Typography } from '@/app/components/ui/Typography';

export default function SignIn() {
  const t = useTranslations();

  return (
    <PageLayout name="signin">
      {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
      <div className="responsive-grid container h-dvh">
        <div className="col-start-4 col-end-13 w-full self-center">
          <ShadCard className="mx-auto w-[496px] gap-6 border border-solid border-white shadow-[0px_0px_60px_rgba(0,0,0,0.08)] tablet:p-12">
            <AlertErrorDynamic />
            <Typography responsiveSize="h2" className="mb-5">
              {t('signin_welcome')}
            </Typography>
            <SignInButtonDynamic
              signInButtonClientProps={{
                translationKey: 'signin_email_login_button',
                signInParams: {
                  acr: 'urn:se:curity:authentication:email:email',
                },
              }}
            />
            <InternalSignInLink />
          </ShadCard>
        </div>
      </div>
      <BulkOrderBackground showImage />
    </PageLayout>
  );
}
